import { Section } from '../../../components/StructureElements/Section'
import { SectionHeaderTypography } from '../../../components/Typographies/SectionHeaderTypography'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { nameOf } from '../../../../utils/functions/ReflectionUtil'
import { CustomInput } from '../../../components/Input/CustomInput'
import { InputWrapper } from '../../../components/Input/InputWrapper'
import { SectionContent } from '../SectionContent'
import { SectionHeader } from '../SectionHeader'
import { CustomInputChangeEvent } from '../../../../utils/models/events/CustomInputChangeEvent'
import { InputLabel } from '../../../components/Input/InputLabel'
import { StrucRow } from '../../../components/StructureElements/StrucRow'
import { StrucCol } from '../../../components/StructureElements/StrucCol'

export interface InvoiceAddressForm {
  invoiceFullName: string
  invoiceAddress: string
  invoiceZipCode: string
  invoiceCity: string
}

export interface InvoiceAddressEditorViewModel {
  onFormChange: (event: React.ChangeEvent<HTMLInputElement> | CustomInputChangeEvent) => void
  disabled: boolean
  form: InvoiceAddressForm
  initialState: boolean
  onToggle: () => void
}

export function InvoiceAddressEditor({ disabled, onFormChange, initialState, form, onToggle }: InvoiceAddressEditorViewModel) {
  const { t } = useTranslation()
  return (
  <Section>
    <SectionHeader isCloseable initialState={initialState} onToggle={onToggle}>
      <SectionHeaderTypography>{t("myProfileSub.invoiceAddress")}</SectionHeaderTypography></SectionHeader>
    <SectionContent close={!initialState}>
      <StrucRow>
        <StrucCol size={3.5}>
          <InputWrapper>
            <InputLabel>{t("myProfileSub.fullName")}</InputLabel>
            <CustomInput
              name={nameOf<InvoiceAddressForm>(lf => lf.invoiceFullName)}
              value={form.invoiceFullName}
              onChange={x => onFormChange(x)}
              disabled={disabled}
            />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>{t("myProfileSub.address")}</InputLabel>
            <CustomInput
              name={nameOf<InvoiceAddressForm>(lf => lf.invoiceAddress)}
              value={form.invoiceAddress}
              onChange={x => onFormChange(x)}
              disabled={disabled}
            />
          </InputWrapper>
        </StrucCol>
        <StrucCol size={3.5} offset={0.5}>
          <InputWrapper>
            <InputLabel>{t("myProfileSub.zipCode")}</InputLabel>
            <CustomInput
              name={nameOf<InvoiceAddressForm>(lf => lf.invoiceZipCode)}
              value={form.invoiceZipCode}
              onChange={x => onFormChange(x)}
              disabled={disabled}
            />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>{t("myProfileSub.city")}</InputLabel>
            <CustomInput
              name={nameOf<InvoiceAddressForm>(lf => lf.invoiceCity)}
              value={form.invoiceCity}
              onChange={x => onFormChange(x)}
              disabled={disabled}
            />
          </InputWrapper>
        </StrucCol>
      </StrucRow>
    </SectionContent>
  </Section>)
}
